import {
  OpportunityPlacement,
  OpportunitiesCategoryTitlesMap as OppersCategoryTitlesMap,
  OpportunitiesPageTitlesMap as OppersPageTitlesMap,
} from 'interfaces/opportunities'
import { DebtAssetCategoryId, IncomeCategoryId, OpportunityCategoryId, OpportunityPredefinedCategoryId, SpendingCategoryId } from 'interfaces/meta'

export const NO_OPPORTUNITIES_TEXT = 'You have no opportunities right now. Check back soon to find new ways to save and earn.'
export const NO_HIGHLIGHTS_TEXT = 'Check back soon to see new highlights.'
export const NO_NEW_OPPORTUNITIES_TEXT = 'You have no new opportunities.'
export const NO_DISMISSED_OPPORTUNITIES_TEXT = 'You don’t have any dismissed opportunities.'

export const OPPORTUNITIES_PAGE_PLACEMENT: OpportunityPlacement = 'opportunities_main'
export const ADVERTISER_DISCLOSURE = 'Advertiser Disclosure'

export const OPPORTUNITY_DEBTS_CATEGORY_IDS: DebtAssetCategoryId[] = [
  'creditcard', 'debt_other', 'debt_auto', 'mortgage', 'home_equity', 'student',
  'savings', 'cd', 'investment', 'asset_other', 'asset_auto', 'home',
]
export const OPPORTUNITY_SPENDING_CATEGORY_IDS: SpendingCategoryId[] = [
  'auto_gas', 'education', 'entertainment', 'fees', 'gifts_charity', 'groceries',
  'health_medical', 'home_improvement', 'housing', 'restaurants', 'shopping',
  'loans', 'travel', 'utilities_bills', 'withdrawals_checks', 'other_expenses',
]
export const OPPORTUNITY_INCOME_CATEGORY_IDS: IncomeCategoryId[] = [
  'salary_regular', 'investment_savings', 'other_income',
]
export const OPPORTUNITY_PREDEFINED_CATEGORY_IDS_SET: Set<OpportunityPredefinedCategoryId> = new Set([
  <const>'top',
  <const>'new',
  <const>'rewardable',
  <const>'dismissed',
])
export const OPPORTUNITY_CATEGORY_IDS: OpportunityCategoryId[] = [
  ...OPPORTUNITY_DEBTS_CATEGORY_IDS,
  ...OPPORTUNITY_SPENDING_CATEGORY_IDS,
  ...OPPORTUNITY_INCOME_CATEGORY_IDS,
  ...Array.from(OPPORTUNITY_PREDEFINED_CATEGORY_IDS_SET),
  <const>'credit_profile',
  <const>'networth',
]

export const OPPORTUNITIES_CATEGORY_TITLES: OppersCategoryTitlesMap = {
  top: 'Top',
  new: 'New',
  rewardable: 'With Rewards',
  dismissed: 'Dismissed',
  credit_profile: 'Credit Profile',
  networth: 'Net Worth',
}

export const OPPORTUNITIES_PAGE_TITLES: OppersPageTitlesMap = {
  top: 'Your Top Opportunities',
  new: 'New Opportunities',
  dismissed: 'Dismissed Opportunities',
  rewardable: 'Your Opportunities With Rewards',
}
